import React from "react";
import { Grid, withStyles, WithStyles } from "@material-ui/core";
import { PICKUP_OPTIMYZER_FILTER_NAME } from "../../constants";
import CheckboxOption from "./CheckboxOption";
import styles from "../styles";

interface PickupFilterOptionConfig {
  name: string;
  title: string;
  description: string;
  getColor: (isPartial: boolean) => "primary" | "default";
  getIndeterminate: (isPartial: boolean) => boolean;
}

const PICKUP_FILTER_OPTIONS: PickupFilterOptionConfig[] = [
  {
    name: PICKUP_OPTIMYZER_FILTER_NAME.isAssigned,
    title: "Assigned pickups",
    description:
      "(Re-evaluates existing assignments based on current driver situations)",
    getColor: (isPartial) => (isPartial ? "default" : "primary"),
    getIndeterminate: (isPartial) => isPartial,
  },
  {
    name: PICKUP_OPTIMYZER_FILTER_NAME.isUnassigned,
    title: "Unassigned pickups",
    description: "(Optimally suggests new pickups)",
    getColor: (isPartial) => (isPartial ? "default" : "primary"),
    getIndeterminate: (isPartial) => isPartial,
  },
  {
    name: PICKUP_OPTIMYZER_FILTER_NAME.excludeSwapPickups,
    title: "Exclude Swap Pickups",
    description: "(Hides swap pickups from the list when checked)",
    getColor: () => "primary",
    getIndeterminate: () => false,
  },
];

export interface PickupCheckboxProps extends WithStyles<typeof styles> {
  isPartialAssignedPickupsSelected: boolean;
  isPartialUnassignedPickupsSelected: boolean;
  isAssigned: boolean;
  isUnassigned: boolean;
  excludeSwapPickups: boolean;
  handleFilterChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PickupCheckbox: React.FC<PickupCheckboxProps> = ({
  classes,
  isPartialAssignedPickupsSelected,
  isPartialUnassignedPickupsSelected,
  isAssigned,
  isUnassigned,
  excludeSwapPickups,
  handleFilterChange,
}) => {
  const filterValues: Record<string, boolean> = {
    [PICKUP_OPTIMYZER_FILTER_NAME.isAssigned]: isAssigned,
    [PICKUP_OPTIMYZER_FILTER_NAME.isUnassigned]: isUnassigned,
    [PICKUP_OPTIMYZER_FILTER_NAME.excludeSwapPickups]: excludeSwapPickups,
  };
  const partialStates: boolean[] = [
    isPartialAssignedPickupsSelected,
    isPartialUnassignedPickupsSelected,
    false,
  ];

  return (
    <Grid container className={classes.infoContainer}>
      <div className={classes.headerLabel}>Select Pickups</div>
      {PICKUP_FILTER_OPTIONS.map((option, index) => (
        <CheckboxOption
          key={option.name}
          checked={filterValues[option.name] ?? false}
          name={option.name}
          title={option.title}
          description={option.description}
          onChange={handleFilterChange}
          color={option.getColor(partialStates[index])}
          indeterminate={option.getIndeterminate(partialStates[index])}
          classes={classes}
        />
      ))}
    </Grid>
  );
};

export default withStyles(styles)(PickupCheckbox);
